import { Component, Input } from '@angular/core';
import { EaBreadcrumb } from '@app/components/pr-breadcrumb/pr-breadcrumb.component';
import { PageHeaderMenu } from '../pr-page-header-menu/pr-page-header-menu.component';

@Component({
    selector: 'pr-page-header',
    templateUrl: './pr-page-header.component.html',
    styleUrls: ['./pr-page-header.component.scss'],
    standalone: false
})
export class PrPageHeaderComponent {
  @Input() breadcrumb: EaBreadcrumb[];
  @Input() title: string;
  @Input() subtitle?: string;
  @Input() secondTitle?: string;
  @Input() otherTitle: string;
  @Input() otherSubtitle: string;
  @Input() hasColorSquare: boolean = true;
  @Input() menus: PageHeaderMenu;
  @Input() tabs: any[];

  constructor() {}
}
